import React, { useState, useEffect } from "react";
import { MdOutlineEdit } from "react-icons/md";
import CustomButton from "../Common/CustomButton";
import EditProfileModal from "./EditProfileModal";
import ConfirmationModal from "./ConfirmationModal";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { updateLastApp } from "../../Redux/Auth/action";
import CopyEmail from "../Common/CopyEmail";

const PROVIDER_APP = process.env.REACT_APP_PROVIDER_URL;
const PATIENT_APP = process.env.REACT_APP_PATIENT_URL;
const PRACTITIONER_APP = process.env.REACT_APP_PRACTITIONER_URL;

const formatStateWord = (stateWord) => {
  return stateWord
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
const ProfileModal = () => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState(
    "https://t4.ftcdn.net/jpg/03/24/22/77/360_F_324227760_73JhXgDh5OFsYuymiMzn6s7FHHzf3Ef0.jpg"
  );
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState("central_admin");
  const SIGNIN = process.env.REACT_APP_SIGNIN_URL;
  const dispatch =  useDispatch()
  const openEditModal = () => {
    setIsEditOpen(true);
  };

  const handleSignOut = () => {
    setIsConfirmOpen(true);
  };

  const confirmSignOut = () => {
    Cookies.remove("tenant");
    Cookies.remove("tenantId");
    Cookies.remove("Token");

    localStorage.clear();

    window.location.href = SIGNIN;
  };

  const cancelSignOut = () => {
    setIsConfirmOpen(false);
  };

  const closeEditModal = () => {
    setIsEditOpen(false);
  };

  const updateProfileImage = (newImageUrl) => {
    setProfileImageUrl(newImageUrl);
    closeEditModal();
  };
  const toggleUserTypeDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const tenantId = Cookies.get("TenantId");
  const userId = Cookies.get("UserId");
  const token = Cookies.get("Token");

  const {profile} =  useSelector((state=>state.userReducer))

  const { firstName = "", lastName = "", email = "" } = profile;
 
  useEffect(() => {
    const findTenant = profile.tenants.find((elm) => elm.tenantId === tenantId);
    if (!findTenant) {
      localStorage.clear();
      return (window.location.href = SIGNIN);
    }
    const { userTypes } = findTenant;
    setUserTypes(() => userTypes);
  }, []);

  const handleUserTypeChange = async(type) => {

    try {
      const response = await dispatch(
        updateLastApp({ userId, body: { appName: type } })
      );
      if (response?.status === 200) { 
        setSelectedUserType(type);
        setIsDropdownOpen(false);
        const portMap = { provider: PROVIDER_APP, practitioner: PRACTITIONER_APP, patient: PATIENT_APP };
        const url = portMap[type]
          ? `${portMap[type]}?vt=${token}&ui=${userId}&ti=${tenantId}`
          : SIGNIN;

        window.location.href = url;
      } else {
        toast.error(response?.data?.message || "An unexpected error occurred.");
      }
    } catch {
    toast.error("Failed to update the last accessed application."); 
    }
    setIsDropdownOpen(false);
  };

  return (
    <>
      <div className="absolute z-40 top-12 right-0 w-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg">
        {/* Header Section with Gradient */}
        <div className="bg-gradient-to-r from-brand-500/10 to-brand-500/5 p-6">
          <div className="flex items-start space-x-4">
            {/* Profile Image */}
            <div className="relative flex-shrink-0">
              <img
                src={profile?.imageUrl}
                alt="Profile"
                className="w-16 h-16 rounded-full object-cover border-2 border-brand-500/20 shadow-md"
              />
              <button
                onClick={() => setIsEditOpen(true)}
                aria-label="Change profile photo"
                title="Change profile photo"
                className="absolute -bottom-1 -right-1 bg-brand-500 rounded-full p-1.5 shadow-lg hover:bg-brand-600 transition-colors"
              >
                <MdOutlineEdit className="text-white w-3.5 h-3.5" />
              </button>
            </div>

            {/* User Info */}
            <div className="flex-1 min-w-0">
              <h2 className="text-lg font-semibold text-gray-800 truncate">
                {firstName} {lastName}
              </h2>
              <p className="text-sm text-gray-500 truncate"><CopyEmail email={email} /></p>
              <span className="inline-flex items-center px-2.5 py-0.5 mt-2 rounded-full text-xs font-medium bg-brand-500/10 text-brand-500">
                {formatStateWord(selectedUserType)}
              </span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-200" />

        {/* Actions Section */}
        <div className="p-4 space-y-3">
          {/* Role Switcher */}
          {/* <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="w-full px-4 py-2 text-left text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span>Switch Role</span>
                <svg
                  className={`w-4 h-4 transition-transform ${
                    isDropdownOpen ? "transform rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </button>

        
            {isDropdownOpen && (
              <div className="absolute z-30 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                {profile?.tenants?.map((tenant) => (
                  tenant.userType !=='central_admin' &&
                  <button
                    key={tenant.tenantId}
                    onClick={() => handleUserTypeChange(tenant.userType)}
                    className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg focus:outline-none focus:bg-gray-50 transition-colors"
                  >
                    {tenant.userType.replace(/_/g, ' ').charAt(0).toUpperCase() + 
                     tenant.userType.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div> */}

          {/* Sign Out Button */}
          <button
            onClick={handleSignOut}
            className="w-full px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>

      {/* Modals */}
      <EditProfileModal
        isOpen={isEditOpen}
        setIsOpen={setIsEditOpen}
        onClose={() => setIsEditOpen(false)}
        profileImageUrl={profile.imageUrl}
        updateProfileImage={setProfileImageUrl}
        userId={profile._id}
        profileId={{              
          _id: profile._id,
          userId: profile.userId
        }}
      />
      <ConfirmationModal
        isOpen={isConfirmOpen}
        onConfirm={confirmSignOut}
        onCancel={() => setIsConfirmOpen(false)}
      />
    </>
  );
};

export default ProfileModal;
